import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "initials" })
export class InitialsPipe implements PipeTransform {
  public transform(name?: string): string {
    const words =
      name
        ?.trim()
        .split(/\s+/)
        .filter((word) => word.length > 0) ?? [];
    const firstInitial = words.at(0)?.charAt(0) ?? "";
    const lastInitial = words.length > 1 ? (words.at(-1)?.charAt(0) ?? "") : "";

    return `${firstInitial}${lastInitial}`.toUpperCase();
  }
}
